/**
 * Type of incasso action taken
 */
export enum IncassoActionType {
  PHONE = 'phone',
  WHATSAPP_MESSAGE = 'whatsapp_message',
  SMS = 'sms',
  EMAIL = 'email',
  REGISTERED_MAIL = 'registered_mail',
}

/**
 * Who initiated the action
 */
export enum IncassoActionInputBy {
  SYSTEM = 'system',
  USER = 'user',
}

/**
 * IncassoAction type for frontend
 */
export interface IncassoAction {
  id: number;
  actionType: IncassoActionType;
  actionDate: string;
  remarks?: string | null;
  inputBy: IncassoActionInputBy;
  createdByUserId?: string;
  odooPartnerId?: number;
  contactId?: number;
  companyId?: number;
  phoneNumber?: string;
  emailAddress?: string;
  durationSeconds?: number;
  createdAt: string;
  updatedAt: string;
}

/**
 * DTO for creating a new incasso action
 */
export interface CreateIncassoActionDto {
  actionType: IncassoActionType;
  actionDate?: string;
  remarks?: string;
  inputBy?: IncassoActionInputBy;
  odooPartnerId?: number;
  contactId?: number;
  companyId?: number;
  phoneNumber?: string;
  emailAddress?: string;
  durationSeconds?: number;
}

/**
 * Labels for action types (Dutch)
 */
export const INCASSO_ACTION_TYPE_LABELS: Record<IncassoActionType, string> = {
  [IncassoActionType.PHONE]: 'Telefoongesprek',
  [IncassoActionType.WHATSAPP_MESSAGE]: 'WhatsApp bericht',
  [IncassoActionType.SMS]: 'SMS',
  [IncassoActionType.EMAIL]: 'E-mail',
  [IncassoActionType.REGISTERED_MAIL]: 'Aangetekende brief',
};

/**
 * Icons for action types (Phosphor icon names)
 */
export const INCASSO_ACTION_TYPE_ICONS: Record<IncassoActionType, string> = {
  [IncassoActionType.PHONE]: 'Phone',
  [IncassoActionType.WHATSAPP_MESSAGE]: 'WhatsappLogo',
  [IncassoActionType.SMS]: 'ChatText',
  [IncassoActionType.EMAIL]: 'Envelope',
  [IncassoActionType.REGISTERED_MAIL]: 'EnvelopeSimple',
};
